module.exports = __webpack_public_path__ + "static/media/1.b4a3dd1f.jpg";